//#region src/types.ts
var C_TYPE = "type";
var C_COMPANY = "companyName";
var C_BTWNR = "vatNr";
var C_FIRSTNAME = "firstName";
var C_LASTNAME = "lastName";
var C_STREET = "street";
var C_CITY = "city";
var C_ADDITIONAL = "additionalHint";
var C_PROPERTY_DATE = "propertyDate";
var C_PHONE1 = "phone1";
var C_EMAIL = "email";
var C_WEBSITE = "website";
var C_SOCIAL_MEDIA = "socialMedia";
//#endregion
export { C_ADDITIONAL, C_BTWNR, C_CITY, C_COMPANY, C_EMAIL, C_FIRSTNAME, C_LASTNAME, C_PHONE1, C_PROPERTY_DATE, C_SOCIAL_MEDIA, C_STREET, C_TYPE, C_WEBSITE };
